import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

/**
 * 1 - Entrevista
 * 2 - Observacao comportamental
 * 3 - Demais observacoes
 */
type fetchSynthesisModel = {
  cdAvaliacao: string | number
  type: 1 | 2 | 3
}

type saveNewSynthesisModel = {
  cdAvaliacao: string | number
}

export const fetchSynthesis = ({ cdAvaliacao, type }: fetchSynthesisModel) => {
  return new ServicesUseCase(
    `/template/sinteses?tipo=${type}&cdAvaliacao=${cdAvaliacao}`,
    makeAxiosHttpClient()
  )
}

export const saveNewSynthesis = ({ cdAvaliacao }: saveNewSynthesisModel) => {
  return new ServicesUseCase(
    `/template/sinteses/save?cdAvaliacao=${cdAvaliacao}`,
    makeAxiosHttpClient()
  )
}

export const updateSynthesis = ({ cdAvaliacao }: saveNewSynthesisModel) => {
  return new ServicesUseCase(
    `/template/sinteses/update?cdAvaliacao=${cdAvaliacao}`,
    makeAxiosHttpClient()
  )
}
